import { inject, IPlatform } from 'aurelia';

@inject(IPlatform)
export class WindowAbstraction {
    private _platform: IPlatform = null;

    constructor(platform: IPlatform) {
        this._platform = platform;
    }

    // eslint-disable-next-line @typescript-eslint/ban-types
    public queue(func: () => void): void {
        this._platform.taskQueue.queueTask(func);
    }

    // eslint-disable-next-line @typescript-eslint/ban-types
    public delay(func: Function, time: number): number {
        const handle = window.setTimeout(func, time);
        return handle;
    }

    public cancelDelay(handle: number): void {
        window.clearTimeout(handle);
    }

    public performRedirect(url: string): void {
        window.location.href = url;
    }

    public navigateToHash(hash: string): void {
        window.location.hash = hash;
    }

    public performReload(): void {
        window.location.reload();
    }

    public getHostname(): string {
        return window.location.hostname;
    }

    public getLocation(): string {
        return window.location.href;
    }

    public openNewTabAndNavigateToUrl(url: string): void {
        window.open(url, '_blank');
        window.focus();
    }

    public disableDragAndDrop(): void {
        const preventDragAndDrop = (e: any) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            e.preventDefault();
            e.dataTransfer.effectAllowed = 'none';
            e.dataTransfer.dropEffect = 'none';
            return false;
        };
        window.addEventListener('dragenter', preventDragAndDrop);
        window.addEventListener('dragover', preventDragAndDrop);
        window.addEventListener('drop', preventDragAndDrop);
    }
}
